import { comingSoonProducts } from "constant/commonConstant";
import { getRegion } from "./utils";

export function productUrlHelper(product: string): string {
  switch (getRegion()) {
    case "asia":
      return process.env[`REACT_APP_${product}_URL_ASIA`] ?? "";
    case "us":
      return process.env[`REACT_APP_${product}_URL_US`] ?? "";
    default:
      return process.env[`REACT_APP_${product}_URL_ASIA`] ?? "";
  }
}

/** Lets the product app replace a session another user left there; see its SessionUserSync. */
export function withSessionUser(url: string, sub?: string): string {
  if (!url || !sub) return url;
  const target = new URL(url);
  target.searchParams.set("uid", sub);
  return target.toString();
}

export function isComingSoonProducts(product: string): boolean {
  return comingSoonProducts.includes(product.toUpperCase());
}
